import React, { useRef, useState } from 'react';
import { LayoutChangeEvent, ScrollView, StyleSheet, View } from 'react-native';
import BodyBaseBoldText from 'shared/components/vxl/typography/primary/body/BodyBaseBoldText';
import theme from 'shared/styles/theme';

import IntervalTrackerItem, { MarkProps } from './base/Marker/Marker';

export interface IntervalTrackerProps {
  trackerStates: MarkProps[];
  trackerHeading?: string;
}

const IntervalTracker = ({
  trackerStates,
  trackerHeading,
}: IntervalTrackerProps) => {
  const trackerScrollViewRef = useRef<ScrollView>(null);
  const itemWidth = trackerStates?.length < 5 ? 56 : 44;
  const itemMargin = theme.spacing.s;
  const [parentWidth, setParentWidth] = useState(0);

  // Function to scroll to a specific index
  const scrollToIndex = () => {
    const activeItemIndex = trackerStates.findIndex(
      (item) => item.status === 'Active',
    );
    if (activeItemIndex !== -1) {
      const offset =
        activeItemIndex * (itemWidth + 2 * itemMargin) -
        (parentWidth - itemWidth) / 2;
      trackerScrollViewRef.current?.scrollTo({ x: offset, animated: true });
    }
  };

  const handleLayout = (event: LayoutChangeEvent) => {
    setParentWidth(event.nativeEvent.layout.width);
    scrollToIndex();
  };

  return (
    <View
      style={styles.containerTracker}
      testID="IntervalTrackerItem"
      onLayout={handleLayout}
    >
      {trackerHeading ? (
        <BodyBaseBoldText numberOfLines={1} style={styles.trackerHeading}>
          {trackerHeading}
        </BodyBaseBoldText>
      ) : null}
      <ScrollView
        ref={trackerScrollViewRef}
        horizontal={true}
        showsHorizontalScrollIndicator={false}
      >
        <View style={styles.trackerContainer} testID="tracker-item-container">
          {trackerStates.map((trackerState, index) => {
            return (
              <IntervalTrackerItem
                trackerState={trackerState}
                trackerSize={trackerStates.length}
                key={trackerState.id}
                position={index}
              />
            );
          })}
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  containerTracker: {
    backgroundColor: theme.color.background.primary,
    gap: theme.spacing.s,
    paddingVertical: theme.spacing.m,
  },
  trackerContainer: {
    flexDirection: 'row',
    gap: theme.spacing.s,
  },
  trackerHeading: {
    paddingLeft: theme.spacing.m,
  },
});

export default IntervalTracker;
